var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8687 0.702718C33.3187 1.1528 33.5714 1.76317 33.5714 2.39959C33.5714 3.03601 33.3187 3.64638 32.8687 4.09646L13.6679 23.2973C13.2178 23.7472 12.6074 24 11.971 24C11.3346 24 10.7242 23.7472 10.2741 23.2973L0.673737 13.6969C0.236539 13.2442 -0.00537771 12.6379 9.07302e-05 12.0086C0.00555917 11.3793 0.257975 10.7774 0.702974 10.3324C1.14797 9.88737 1.74995 9.63495 2.37925 9.62948C3.00855 9.62401 3.61482 9.86593 4.06748 10.3031L11.971 18.2067L29.475 0.702718C29.9251 0.252768 30.5354 0 31.1718 0C31.8083 0 32.4186 0.252768 32.8687 0.702718Z",
    fill: "#73D13D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck3);
export default __webpack_public_path__ + "static/media/check_3.15e93fae3b3254fe371f2920818e017c.svg";
export { ForwardRef as ReactComponent };